export default __webpack_public_path__ + "static/media/appstore.289c3b5b.svg";